export default {
  toasts: {
    failed_to_create_website: 'Creazione sito web non riuscita',
  },
  steps: {
    information: 'Informazioni',
    template: 'Template',
  },
  buttons: {
    next: 'Avanti',
    previous: 'Indietro',
    create_website: 'Crea sito web',
    preview_about_us: 'Chi siamo (Anteprima)',
  },
  about_us_modal: {
    title: 'Chi siamo (Anteprima)',
  },
  error_messages: {
    missing_fields: 'Alcuni campi obbligatori mancano. Compila tutte le informazioni necessarie prima di procedere.',
  },
};
